interface SpinnerProps {
  label?: string
}

/** Small inline spinner shown next to async actions with no other progress feedback (e.g. file
 *  uploads, which otherwise give no visual cue until the result appears - user-task-002). */
export function Spinner({ label }: SpinnerProps) {
  return (
    <span className="spinner-inline" role="status" aria-live="polite">
      <span className="spinner" aria-hidden="true" />
      {label && <span>{label}</span>}
    </span>
  )
}
